import { render, staticRenderFns } from "./PasswordSuccess.vue?vue&type=template&id=c739496c&scoped=true&"
import script from "./PasswordSuccess.vue?vue&type=script&lang=js&"
export * from "./PasswordSuccess.vue?vue&type=script&lang=js&"
import style0 from "./PasswordSuccess.vue?vue&type=style&index=0&id=c739496c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c739496c",
  null
  
)

export default component.exports